
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/anchors/components/anchorVariables.scss.css.virtualfile';
        module.exports = {"anchorHandleWidth":"140px","anchorHandleHeight":"24px","anchorHandleMarginRight":"68px"};